export default class VehicleTradeproposal {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.input = this.DOM.el.querySelector('[data-vehicle-tradeproposal-input]');
        this.DOM.button = this.DOM.el.querySelector('[data-vehicle-tradeproposal-button]');

        this.initEvents();
    }

    initEvents() {
        /* Add event listener */
        this.DOM.input?.addEventListener('change', (e) => {
            this.DOM.button?.setAttribute('data-flow-query-params', JSON.stringify({ license_plate: e.target.value || '' }));
        });
    }
}

const vehicleTradeproposalNodes = Array.from(document.querySelectorAll('[data-vehicle-tradeproposal]'));
if (vehicleTradeproposalNodes !== null) {
    vehicleTradeproposalNodes.forEach((node) => { new VehicleTradeproposal(node); });
}
